import React, { useState, useEffect } from "react";

const NewsModal = ({ isOpen, onClose, newsItem, onSave }) => {
  const [message, setMessage] = useState(newsItem ? newsItem.message : "");
  const [isactive, setIsactive] = useState(
    newsItem ? newsItem.is_active === "1" : false
  );
  const [error, setError] = useState("");
  const [pdfFile, setPdfFile] = useState(newsItem ? newsItem.pdf_file : null);

  useEffect(() => {
    if (newsItem) {
      setMessage(newsItem.message);
      setIsactive(newsItem.is_active === "1");
      setPdfFile(newsItem.pdf_file);
    }
  }, [newsItem]);

  const handleSave = () => {
    setError("");
    onSave({
      ...newsItem,
      message,
      pdf_file: pdfFile,
      is_active: isactive ? "1" : "0",
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setPdfFile(file);
    } else {
      setError("Please upload a valid PDF file.");
    }
  };

  return isOpen ? (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
      <div className="bg-white p-6 rounded-md w-[50%] shadow-md">
        <h2 className="text-xl font-semibold mb-4">
          {newsItem ? "Edit News" : "Create News"}
        </h2>
        <label className="block mb-2 font-bold">News Title</label>
        <textarea
          className="w-full h-24 border border-gray-300 rounded-md"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        {/* File input for PDF */}
        <div className="mt-4">
          <label className="block mb-2 font-bold" htmlFor="pdfFile">
            Upload PDF
          </label>
          <input
            type="file"
            id="pdfFile"
            accept="application/pdf"
            onChange={handleFileChange}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
          {/* {pdfFile && <p className="mt-2">Selected file: {pdfFile.name}</p>} */}
        </div>
        <div className="flex items-center mt-2">
          <input
            type="radio"
            id="active"
            name="isactive"
            checked={isactive}
            onChange={() => setIsactive(true)}
          />
          <label htmlFor="active" className="ml-2">
            Active
          </label>
          <input
            type="radio"
            id="inactive"
            name="isactive"
            checked={!isactive}
            onChange={() => setIsactive(false)}
            className="ml-4"
          />
          <label htmlFor="inactive" className="ml-2">
            Inactive
          </label>
        </div>

        {error && <div className="text-red-500 mt-2">{error}</div>}
        <div className="mt-4 flex justify-end">
          <button
            onClick={handleSave}
            className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 mr-2"
          >
            Save
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default NewsModal;
